import { render, staticRenderFns } from "./NewsOverview.vue?vue&type=template&id=618df257&scoped=true&"
import script from "./NewsOverview.vue?vue&type=script&lang=js&"
export * from "./NewsOverview.vue?vue&type=script&lang=js&"
import style0 from "./NewsOverview.vue?vue&type=style&index=0&id=618df257&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618df257",
  null
  
)

export default component.exports